
import APIService from "../../services/api.service";
import { CacheService } from '../../common/services/cache.service';
import APIOptions from "../../models/apiOptions";
import environment from "../../environment/environment";
import SearchResults from "../../models/searchResult";

const axios = require('axios');

const getSearchResults = (...args) => {
  const filterText = args[0];
  const filterOptions = args[1];
  let queryString = `?allfields=${filterText}`;
  // check if filterOptions is has keys
  if (Object.keys(filterOptions).length > 0) {
    queryString += `&${Object.keys(filterOptions).map(key => key + '=' + filterOptions[key])}`;
  }
  
  const url = `${environment.eticApiUrl}search${queryString}`;
  const apiOptions: APIOptions = new APIOptions(url, SearchResults);
  const T = apiOptions.T;

  const apiService = new APIService<typeof T>(axios, new CacheService, apiOptions.url);
  return apiService.getAnyAsync();
}

const getUploadsByUser = (...args) => {
  const axios = require('axios');
  const user = 'tbarnhart';
  const url = `${environment.apiUrl}search?submitter=${user}`;
  const apiOptions: APIOptions = new APIOptions(url, SearchResults);
  const T = apiOptions.T;

  const apiService = new APIService<typeof T>(axios, new CacheService, apiOptions.url);
  return apiService.getAnyAsync();
}


export default {
  getSearchResults,
  getUploadsByUser
};